export default __webpack_public_path__ + "static/media/icon_storedb.7d549229.svg";